module.exports = __webpack_public_path__ + "img/9.94e08683.png";